<!-- REVISION = 20220308194202 -->

<script>
	import Menu from './Menu.svelte';
	import Category from './Category.svelte';

	// import { beforeUpdate, afterUpdate } from 'svelte';

	let slugRaw = window.location.pathname.replaceAll('/', '');
	let slug = slugRaw || 'dependency-management';

	// beforeUpdate(() => {
	// 	console.log('slug before update in <App/>', slug) //DEBUG
	// });

	// afterUpdate(() => {
	// 	console.log('slug after update in <App/>', slug) //DEBUG
	// });
	
</script>

<main>
	<h1><a href="/">PHP8.link</a></h1>
	<div class="container">
        <div class="row justify-content-start">
            <section class="col-sm-12 col-md-3 col-lg-2">
                <Menu bind:menu_active_item={slug} />
            </section>
            <section class="col-sm-12 col-md-9 col-lg-10">
                <Category slug={slug} />
            </section>
            <!-- <section class="col-2">
				Table of Conent
                Sponsor
            </section> -->
        </div>
	</div>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		/* max-width: 240px; */
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}
	
	h1 > a {
		color: #ff3e00;
		text-decoration: none;
	}

	h1 > a:hover {
		color: #6BA81E;
	}

	/* @media (min-width: 640px) {
		main {
			max-width: none;
		}
	} */
</style>